import script from "./ServicerMailingInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServicerMailingInformation.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/loans/form.css?vue&type=style&index=0&id=c1eb00c0&scoped=true&lang=css&external"
import "./ServicerMailingInformation.vue?vue&type=style&index=1&id=c1eb00c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1eb00c0"]])

export default __exports__